import React from 'react';
// @TODO Create common snippet ratingStars to reuse in places with ratingStars
const Star = ({
  fillPercentage
}) => {
  const clipPathId = `starClip-${fillPercentage}`;
  return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/React.createElement("rect", {
    x: ".5",
    y: "0",
    width: 14 * fillPercentage / 100,
    height: "14"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AF60",
    d: "M6.806 1.55c.153-.312.23-.468.334-.518a.333.333 0 0 1 .287 0c.105.05.181.206.335.517L9.22 4.502c.045.092.068.138.101.174.03.032.065.057.104.075.044.02.095.028.196.043l3.26.477c.344.05.516.075.595.159.07.073.102.173.089.273-.015.114-.14.235-.388.478l-2.359 2.297a.73.73 0 0 0-.134.15.333.333 0 0 0-.04.122c-.005.048.003.099.02.2l.557 3.245c.059.342.088.513.033.615a.333.333 0 0 1-.232.169c-.114.02-.267-.06-.575-.222l-2.915-1.533c-.09-.048-.136-.072-.184-.08a.334.334 0 0 0-.128 0c-.048.008-.094.032-.184.08L4.12 12.757c-.307.162-.46.243-.574.222a.333.333 0 0 1-.232-.17c-.055-.1-.026-.272.033-.614l.556-3.245c.017-.101.026-.152.02-.2a.333.333 0 0 0-.04-.122.73.73 0 0 0-.133-.15L1.39 6.18c-.248-.242-.372-.363-.387-.477-.013-.1.02-.2.088-.273.08-.084.252-.11.595-.16l3.26-.476a.729.729 0 0 0 .197-.043.333.333 0 0 0 .104-.075c.033-.036.055-.082.1-.174L6.807 1.55Z",
    clipPath: `url(#${clipPathId})`
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F0AF60",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".595",
    d: "M6.806 1.55c.153-.312.23-.468.334-.518a.333.333 0 0 1 .287 0c.105.05.181.206.335.517L9.22 4.502c.045.092.068.138.101.174.03.032.065.057.104.075.044.02.095.028.196.043l3.26.477c.344.05.516.075.595.159.07.073.102.173.089.273-.015.114-.14.235-.388.478l-2.359 2.297a.73.73 0 0 0-.134.15.333.333 0 0 0-.04.122c-.005.048.003.099.02.2l.557 3.245c.059.342.088.513.033.615a.333.333 0 0 1-.232.169c-.114.02-.267-.06-.575-.222l-2.915-1.533c-.09-.048-.136-.072-.184-.08a.334.334 0 0 0-.128 0c-.048.008-.094.032-.184.08L4.12 12.757c-.307.162-.46.243-.574.222a.333.333 0 0 1-.232-.17c-.055-.1-.026-.272.033-.614l.556-3.245c.017-.101.026-.152.02-.2a.333.333 0 0 0-.04-.122.73.73 0 0 0-.133-.15L1.39 6.18c-.248-.242-.372-.363-.387-.477-.013-.1.02-.2.088-.273.08-.084.252-.11.595-.16l3.26-.476a.729.729 0 0 0 .197-.043.333.333 0 0 0 .104-.075c.033-.036.055-.082.1-.174L6.807 1.55Z"
  }));
};
const roundToNearestHalf = value => {
  return Math.round(value * 2) / 2;
};
const RatingStars = ({
  score,
  classname
}) => {
  if (score < 0 || score > 5) {
    return null;
  }
  const roundedScore = roundToNearestHalf(score);
  const fullStars = Math.floor(roundedScore);
  const halfStar = roundedScore % 1 !== 0;
  const emptyStars = Math.floor(5 - roundedScore);
  return /*#__PURE__*/React.createElement("div", {
    className: classname || ''
  }, Array.from({
    length: fullStars
  }, (_, i) => /*#__PURE__*/React.createElement(Star, {
    key: `full-${i}`,
    fillPercentage: 100
  })), halfStar && /*#__PURE__*/React.createElement(Star, {
    key: "half",
    fillPercentage: 50
  }), Array.from({
    length: emptyStars
  }, (_, i) => /*#__PURE__*/React.createElement(Star, {
    key: `empty-${i}`,
    fillPercentage: 0
  })));
};
export default RatingStars;